import BookForm from "./BookForm";
import React, { useEffect } from "react";
import { AiFillInfoCircle, AiOutlineArrowLeft } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaTimes } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import TopNav from "../TopNav/TopNav";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import NewHeader from "../NewHeader/NewHeader";
import Header from "../Header/Header";
import { useState } from "react";

import moment from "moment";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import { DesktopBack, BackToscreenIcon } from "../Cart/Cart";
import { Scroll } from "../Scroll function/scroll";

import "./planAddress.css";
import { getCartDetails, CreateBooking, SeletSlot } from "../../Redux/Actions";

import Actions from "./PlanSlotAction";

function PlanSlot(props) {
  var date = new Date();

  const [coupnDis, setCoupn] = useState(props.location.state ?? 0);
  const [showDetails, setShowDetails] = useState(true);
  const dispatch = useDispatch();
  const history = useHistory();

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const currentcity = citySelected.citySelect;
  //selecting cart data
  const cartDetails = useSelector((state) => state.CartReducer);
  //selecting create booking response
  const responseFromBooking = useSelector(
    (state) => state.CreateBookingReducer
  );
  const { loading: responseLoading } = responseFromBooking;

  console.log("response", responseFromBooking);
  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage?.getItem("user") ?? null);
    var token = userFromLocal.token ?? null;

    dispatch(getCartDetails(token, currentcity));
  }, []);

  const { loading: cartLoading, cartDetails: cartdata } = cartDetails;

  const [calenderDates, setCalenderDates] = useState([]);
  const [appointmentSlots, setAppointmentSlots] = useState([]);
  const [timeNow, setTimeNow] = useState(new Date().getHours());
  const [TimeSlotBack, setTimeSlotBack] = useState();
  const [selDate, setSelDate] = useState({
    formattedDate: moment(new Date()).format("DD MMM"),
    date: moment(new Date()).format("YYYY-MM-DD"),
  });
  const [timeSlot, setTimeSlot] = useState("");

  const [dateIndex, setDateIndex] = useState(0);

  const [showSuccess, setSucess] = useState(false);
  useEffect(() => {
    if (dateIndex == 0) {
      setSelDate(calenderDates[0]);
    }
  }, [selDate, timeSlot]);

  useEffect(() => setCalender(), []);
  const setCalender = () => {
    let tempCaldrDates = [];
    for (let index = 0; index < 4; index++) {
      let tempObj = {
        formattedDate: moment()
          .add(index, "day")
          .format("DD MMM")
          .toUpperCase(),
        date: moment()
          .add(index, "day")
          .format("YYYY-MM-DD"),
      };
      tempCaldrDates.push(tempObj);
    }
    setCalenderDates(tempCaldrDates);
  };

  useEffect(() => {
    Scroll();
  }, []);

  useEffect(() => {
    if (selDate) {
      props.getAppointmentSlots(selDate);
    }
  }, [selDate]);

  useEffect(() => {
    setAppointmentSlots(props?.appointmentSlots);
  }, [props?.appointmentSlots]);

  var deliveryCharges = 0;
  const [details, setDetails] = useState([]);

  useEffect(() => {
    if (
      cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product
    ) {
      setDetails(cartDetails.cartDetails[0].product);
    }
  }, [cartDetails && cartDetails]);

  if (details !== "") {
    var sum = details.reduce((currentSum, nextObject) => {
      // Note that you need to coerce points_earned
      // to a Number or it will simply concatenate the strings
      return (currentSum += nextObject?.package?.package_city_prices
        ? nextObject?.package?.package_city_prices?.package_price
        : nextObject?.package?.package_price);

      // 0 is your initial value used by currentSum in
      // the first iteration
    }, 0);

    console.log("this is some", sum);
  }
  if (details !== "") {
    var offerSum = 0;
    let numOfTrue = 0;
    // console.log(details, "Lenght Detail obj")
    details.map((item) => {
      if (item?.package?.is_addon) {
        numOfTrue += 1;
      }
    });

    if (details.length == numOfTrue) {
      console.log("all are add on packages");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        currentOfferSum += nextObject?.package?.package_city_prices
          ? nextObject?.package?.package_city_prices?.offer_price
          : nextObject?.package?.offer_price;
        console.log(
          nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price,
          "Now only offer price"
        );
        return currentOfferSum;
      }, 0);
    } else {
      // props.setAllAddonFalse()
      console.log("all are not add on");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        if (nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.addon_price;
          console.log(
            nextObject?.package?.addon_price,
            " Add on price package found"
          );
        } else if (!nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price;
          console.log(
            nextObject?.package?.package_city_prices
              ? nextObject?.package?.package_city_prices?.offer_price
              : nextObject?.package?.offer_price,
            "Offer price/pack citywise package found"
          );
        }
        return currentOfferSum;
      }, 0);
    }

    if (offerSum < 99) {
      deliveryCharges = 200;
    }
  }
  if (details !== "") {
    var discountSum = sum - offerSum;
    var discountPercent = Math.floor((discountSum / sum) * 100);
  }

  const PackageListAry = () => {
    let array = [];
    cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product.forEach((item) => {
        array.push(item.package.id);
      });

    localStorage?.setItem("packageListArray", array);
    return array;
  };

  const productListArray = PackageListAry();

  const handleSubmit = () => {
    if (timeSlot !== "") {
      dispatch(SeletSlot(timeSlot, selDate.date));
      history.push({
        pathname: "/or",
        state: coupnDis,
      });
    } else {
      window.alert("Please select a booking slot");
    }
  };
  const filterTimeSlot = () => {
    if (
      selDate &&
      selDate.formattedDate &&
      parseInt((selDate?.formattedDate?.split(" "))[0]) == new Date().getDate()
    ) {
      var dateNow = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
      const timeSlotAvail = appointmentSlots.filter((item) => {
        var dateThen = moment(new Date()).format(
          `DD/MM/YYYY ${item?.start_time}`
        );
        var timeDiff = moment(dateThen, "DD/MM/YYYY HH:mm:ss").diff(
          moment(dateNow, "DD/MM/YYYY HH:mm:ss")
        );
        // console.log(timeDiff,item?.start_time,"<<<<<")
        return timeDiff > 7200000 && item?.available_slots > 0;
      });
      return timeSlotAvail;
    } else {
      return appointmentSlots;
    }
  };

  useEffect(() => {
    if (responseFromBooking?.create) {
      setSucess(true);
    }
  }, [responseFromBooking]);

  const Switch = () => {
    history.push("/or");
  };
  // const filterForActiveTime = () => {
  //  const timeSlotAva = filterTimeSlot().filter((item)=>{
  //     return item?.available_slots > 0
  //   })
  //   return timeSlotAva
  // }

  // console.log("SELECTED DATE AND TIME", timeSlot, "and", selDate);

  return (
    <>
      <NewHeader />
      <BackToscreenIcon title="Add Slot" currpath="slot" />
      {/* {showSuccess ? (
        <div className="successWindow">
          <div className="successBoking">
            <div className="crossDivSuccess">
              <span>
                <FaTimes onClick={() => Switch()} />
              </span>{" "}
            </div>
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/177d9ba6-c2ff-4b1d-ba96-33f6460bb534.svg"
              alt=""
            />

            <p>We've Successfully received your booking!</p>
          </div>
        </div>
      ) : null} */}

      {responseLoading ? (
        <Loader />
      ) : responseFromBooking && responseFromBooking.error ? (
        <div className="createSuccess">error</div>
      ) : // ) : responseFromBooking.create && responseFromBooking.create !== "" ? (
      // <div className="createSuccess">
      //   <p>Your Booking has been Confirmed </p>
      //   {
      //     () => setSucess(!showSuccess),
      //     console.log("set form")
      //   }

      // </div>
      null}
      <div className="container">
        <DesktopBack title="Add Slot" currpath="slot" />
      </div>

      <div className="planAddDiv">
        <div className="leftSIde">
          {/* <div className="AddressHeaindg">
            <span className="leftArrow">
              <AiOutlineArrowLeft />
            </span>{" "}
            Add Slot
          </div> */}
          <div className="forpadding">
            <div className="slotboxDiv">
              <div className="slotBoxsubDiv">
                <div className="slotBox1">
                  <p>Select Appointment Date</p>
                </div>
                <div className="slotBox2">
                  {calenderDates.map((obj, index) => (
                    <span
                      className={obj == selDate ? "slotDates" : "slotDates2"}
                      onClick={() => {
                        setSelDate(obj);
                        // console.log(obj, "<<<<");
                        setDateIndex(index);
                        setTimeSlot("");
                      }}
                      key={index}
                    >
                      {" "}
                      {obj.formattedDate}{" "}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="slotAppointmentDiv">
              <div className="slotBox1">
                <p>Select Appointment Time</p>
              </div>
              <form className="slotBox">
                {filterTimeSlot().length > 0 ? (
                  filterTimeSlot().map((item, index) => {
                    return (
                      <div key={index} className="slotBox3">
                        <p>
                          {item.start_time_12hr} - {item.end_time_12hr}
                        </p>{" "}
                        <input
                          name="slot"
                          type="radio"
                          style={{ width: "2rem", height: "2rem" }}
                          onClick={() => {
                            setTimeSlot(item);
                          }}
                        />
                      </div>
                    );
                  })
                ) : (
                  <h2>No Slot Available</h2>
                )}
              </form>
            </div>
          </div>
        </div>
        <div className="rightside_section">
          {cartLoading ? (
            <Loader />
          ) : (
            cartDetails &&
            cartDetails.cartDetails &&
            cartDetails.cartDetails[0] &&
            cartDetails.cartDetails[0].product && (
              <div>
                <div className="booking_Razordiv">
                  <div className="topRazor">
                    <p>
                      <span className="textblueBold offerprice">
                        ₹{details !== "" ? offerSum : offerPrice && offerPrice}
                      </span>
                      &nbsp;{" "}
                      <span className="sellingPrice">
                        ₹{details !== "" ? sum : Mrp && Mrp}
                      </span>
                    </p>
                    {/* <span className="btn_neon">Get {discountPercentage}% OFF</span> */}
                    <span className="btn_neon">
                      Get{" "}
                      {details !== ""
                        ? discountPercent
                        : discountPercentage && discountPercentage}
                      % OFF
                    </span>
                  </div>
                  <div className="borderBook" />
                  <div className={showDetails ? "toogleBook" : "height0"}>
                    <div className="priceBreakParent">
                      <span>Home Collection Charges</span>
                      <div className="rightSidediv_booking">
                        {/* <span>₹250</span> */}
                        <span className="textSecondary">FREE</span>
                      </div>
                    </div>
                    <div className="borderBook" />

                    <div className="priceBreakParent">
                      <span>Offer Price</span>
                      <div>
                        {/* <span>₹{packageDetails?.package_price}</span> */}
                        {/* <span>₹ {details !== "" && sum}</span> */}₹
                        {details !== "" ? offerSum : offerPrice && offerPrice}
                      </div>
                    </div>

                    <div className="priceBreakParent">
                      <span>Delivery Charges</span>
                      <div>
                        <span>₹{deliveryCharges}</span>
                      </div>
                    </div>

                    {/* <div className="priceBreakParent">
                      <span>Discount</span>
                      <div>
                        <span>₹ - {details !== "" && discountSum}</span>
                      </div>
                    </div> */}
                    {coupnDis > 0 ? (
                      <div className="priceBreakParent">
                        <span className="coupnSpan">
                          {localStorage?.getItem("is_redcash_applied") == "true"
                            ? "Redcash"
                            : localStorage?.getItem("giftcard") != null &&
                              localStorage?.getItem("giftcard") != ""
                            ? "Giftcard"
                            : "Coupon"}{" "}
                          Applied
                        </span>
                        <div>
                          <span>-₹ {coupnDis}</span>
                        </div>
                      </div>
                    ) : null}
                    <div className="borderBook" />
                    <div
                      className="priceBreakParent"
                      style={{
                        fontWeight: " 700",
                        fontSize: "1.8rem",
                        color: "#0a406b",
                      }}
                    >
                      <span>Total Amount</span>
                      <div>
                        <span>
                          ₹{" "}
                          {details !== ""
                            ? offerSum + deliveryCharges - coupnDis
                            : finalPrice && finalPrice}
                        </span>
                      </div>
                    </div>
                  </div>

                  <span className="guidelines">
                    *inclusive of all the taxes, fees and subject to
                    availability
                  </span>
                  {/* <div className="borderBook" />
                  <div
                    className="price_Break"
                    onClick={() => setShowDetails(!showDetails)}
                  >
                    <span className="textSecondary">
                      {" "}
                      {showDetails
                        ? "Hide Price Breakup"
                        : "Show Price Breakup"}{" "}
                    </span>{" "}
                    <FiChevronDown />
                  </div> */}
                </div>

                <div className="booking_Razordiv">
                  <p className="textSecondary note">
                    YOU SAVED Rs. {details !== "" && discountSum + coupnDis} ON
                    THIS BOOKING!
                  </p>
                  {/* <div className="coupnCODE">
        <input placeholder="Enter Coupon Code" />{" "}
        <span className="textpink"> Apply</span>
      </div> */}
                  <span className="add_tocart " onClick={handleSubmit}>
                    {details !== "" && discountSum && "NEXT"}
                  </span>
                </div>
              </div>
            )
          )}
          {/* <BookForm /> */}
        </div>
      </div>

      <div className="floatingBooking">
        <div className="border-book">
          <div className="price">
            <span style={{ textDecoration: "line-through", color: "gray" }}>
              Rs. {details !== "" && sum}/-
            </span>{" "}
            <span className="PriceColor">
              Rs.{" "}
              {details !== ""
                ? offerSum + deliveryCharges - coupnDis
                  ? offerSum + deliveryCharges - coupnDis
                  : 0
                : finalPrice && finalPrice}
              /-
            </span>
          </div>
          <div className="discount">
            <span>
              Get{" "}
              {details !== ""
                ? discountPercent
                : discountPercentage && discountPercentage}
              % OFF
            </span>
          </div>
          <div className="New_bookNow">
            <span onClick={handleSubmit}>NEXT</span>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  appointmentSlots: state?.Slot?.getAppointmentSlots,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getAppointmentSlots: (date, token) =>
      dispatch(Actions.getAppointmentSlots(date, token)),
    setTimeSlotGlobal: (SelectedTimeSlot, appointmentDate) =>
      dispatch(Actions.setTimeSlotGlobal(SelectedTimeSlot, appointmentDate)),
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(PlanSlot),
};
